import { isNewPlayerEnabled } from 'lib/playerFeatureFlag';
import PlayerUrlChecker from './PlayerUrlChecker';
import NewPlayerUrlChecker from './NewPlayerUrlChecker';
import withSvpPlayer from './withSvpPlayer';
import withNewPlayer from './NewWithSvpPlayer';
import LegacyPlayer, { PLAYER_STATE } from './Player';
import NewPlayer from './NewPlayer';

const newPlayer = isNewPlayerEnabled();
const PlayerComponent = newPlayer ? NewPlayer : LegacyPlayer;
const UrlCheckerComponent = newPlayer ? NewPlayerUrlChecker : PlayerUrlChecker;
const PlayerHOC = newPlayer ? withNewPlayer : withSvpPlayer;

export const PurePlayer = PlayerHOC(PlayerComponent);
export { PLAYER_STATE };
export default PlayerHOC(UrlCheckerComponent);
